// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".md-field{border-radius:5px}.wpwl-control{height:40px!important;min-height:30px!important}.wpwl-button .wpwl-button-pay{display:none!important}.wpwl-button .wpwl-button-pay:after{content:\"whatever it is you want to add\"!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
